<style lang="sass" scoped>

</style>

<template lang="pug">
div.data-section
  h3 TIPOS DE ENTRADA
  div.my-2
    div.list-item(v-for='(item, i) in tickets' :key='i')
      div.space-btw.pa-4
        div {{ item.name }}
        v-btn(icon @click='openDialog(item.id)')
          v-icon mdi-pencil
      v-divider(v-if='i < tickets.length - 1')
  v-dialog(v-model='updateLimitDialog' width='600px')
    v-card
      v-card-title
        | Ajustar Limite
        v-spacer
        v-btn(icon @click='updateLimitDialog = false')
          v-icon mdi-close
      v-card-text
        v-form(ref='form')
          v-text-field(type='number' min=0 label='Novo limite' v-model='newLimit')
      v-card-actions
        v-btn(@click='$refs.form.reset()' :disabled='loading') Limpar
        v-spacer
        v-btn(@click='updateLimit()' :loading='loading') Salvar
  v-snackbar(v-model='snackbar')
    div Limite atualizado!
    v-btn(@click='snackbar = false' icon)
      v-icon mdi-close
</template>

<script>
import utils from '../../utils/requests'

export default {
  props: {
    id: String
  },
  data () {
    return {
      tickets: [],
      newLimit: 0,
      updateLimitDialog: false,
      snackbar: false,
      currentTicketId: '',
      loading: false
    }
  },
  mounted () {
    utils.postAPI('/event/retrieve_event_ticket_types', { id: this.id }).then(res => {
      this.tickets = res.ticket_types
      console.log('tickets: ', res)
    })
  },
  methods: {
    openDialog (id) {
      this.currentTicketId = id
      this.updateLimitDialog = true
    },
    updateLimit () {
      this.loading = true
      const data = {
        'ticket_type_id': this.currentTicketId,
        'new_limit': this.newLimit
      }
      utils.postAPI('/event/update_ticket_type_limit', data).then(res => {
        console.log(res)
        this.loading = false
        this.updateLimitDialog = false
        this.snackbar = true
        window.location.reload()
      })
    }
  }
}
</script>
